module.exports = __webpack_public_path__ + "assets/img/knead.5f39b257.png";